import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Device } from "../interfaces/EndpointInterfaces";
import { getUsers } from "./Api/EndpointApi";
import { myLocalStorage } from "../../StorageHelper";
import useUserStore from "../../../services/userStore";
interface SSHSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  device: Device | null;
  onSave: (deviceId: string, username: string, port: number) => void;
}

export default function SSHSettingsDialog({
  open,
  onOpenChange,
  device,
  onSave
}: SSHSettingsDialogProps) {
  const [username, setUsername] = useState("");
  const [port, setPort] = useState(device?.accessPort ? String(device.accessPort) : "22");
  const [usersList, setUsersList] = useState<any[]>([]);
  let tenantName = myLocalStorage.getItem("latestTenant")?.tenantName;
  const { role, userId, email } = useUserStore((state) => state.user);

  const handleSubmit = () => {
    if (device && username.trim()) {
      onSave(device.id, username.trim(), Number(port));
      setUsername("");
      setPort(device?.accessPort ? String(device.accessPort) : "22");
      onOpenChange(false);
    }
  };


  const handleCancel = () => {
    setUsername("");
    setPort("22");
    onOpenChange(false);
  };

  useEffect(() => {
    if (device) {
      const fetchData = async () => {
        const usersData = await getUsers(tenantName, device.id, role, email);
        setUsersList(usersData);
      };

      if (open) fetchData();
    }

  }, [device, email, open, role, tenantName]);

  useEffect(() => {
    const connectUser = device?.connectionCreatedFor?.find(
      (user) => user.userId === userId && user.role === role,
    );
    const deviceUser = usersList?.find(
      (user) => user.id === userId && user.role === role,
    );

    if (connectUser) setUsername(connectUser.username);
    else if (deviceUser) setUsername(deviceUser.email);

  }, [usersList]);




  if (!device) return null;




  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="ssh-settings-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-slate-800 dark:text-slate-100">
            Connection configuration
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div>
            <p className="mb-3 text-sm text-slate-600 dark:text-slate-400">
              Enter username
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="username" className="text-sm font-medium text-blue-600 dark:text-blue-400">
              Username
            </Label>
            <Input
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              className="border-blue-300 focus:border-blue-500 focus:ring-blue-500"
              data-testid="input-username"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="port" className="text-sm font-medium text-slate-600 dark:text-slate-400">
              Port
            </Label>
            <Input
              id="port"
              value={port}
              onChange={(e) => setPort(e.target.value)}
              placeholder="22"
              type="number"
              className="border-slate-300 focus:border-slate-500 focus:ring-slate-500"
              data-testid="input-port"
            />
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={handleCancel}
            data-testid="button-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!username.trim()}
            className="text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300"
            data-testid="button-submit"
          >
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}